export type GuidePage = {
  title: string
  image: string
  alt: string
}

export const guidePages: GuidePage[] = [
  {
    title: 'Zombie Escape',
    image: 'https://cdn.magicpatterns.com/uploads/cymmKqLeAb2qbJ5uGiRqWw/Captura_de_pantalla_2026-10-09_171326.webp',
    alt: 'Zombie Escape guide page: gym setup diagram with safe lines, 4 how-to-play steps, easier and harder variations, coaching cue and safety note',
  },
  {
    title: 'Monster Maze',
    image: 'https://cdn.magicpatterns.com/uploads/g1VPm5TStDZUxEu9Y528Ke/Captura_de_pantalla_2026-10-09_171414.webp',
    alt: 'Monster Maze guide page: 5-part obstacle course diagram from start to finish and Halloween movement cards for each round',
  },
  {
    title: 'Witch’s Delivery',
    image: 'https://cdn.magicpatterns.com/uploads/j1vLyyVkGTQhSHxahCaCdS/Captura_de_pantalla_2026-10-09_171514.webp',
    alt: 'Witch’s Delivery guide page: cone path lanes to cauldrons, 4 steps, challenge, easier, level-up and safety tips',
  },
  {
    title: 'Skeleton Builder',
    image: 'https://cdn.magicpatterns.com/uploads/9uiwX7CSKPN8cjk6k86nP8/Captura_de_pantalla_2026-10-09_171551.webp',
    alt: 'Skeleton Builder guide page: gym map with skeleton parts, skeleton assembly diagram, movement challenges and 5-step how it works',
  },
]
